// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"6ec7ce1f","872":"0e05c417","969":"caa885db"}[chunkId] + ".chunk.css";
};